import React, { useState } from 'react';
import { Link } from 'gatsby';
import { Posts } from 'components/Blog'
import { prepareData } from 'utils/googleData'

  export  function FilteredPosts(props) {
    const [allTutorialsPostsFilter, setAllTutorialsPostsFilter] = useState('recent');
    // console.log('Current filter:', allTutorialsPostsFilter);
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, tutorialsPopular,tutorialsRecent } = prepareData({
        props,
    })
    // console.log('tutorialsPopular', JSON.stringify(tutorialsPopular))
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
  const posts = allTutorialsPostsFilter === 'popular' ? tutorialsPopular : tutorialsRecent;
  const sectionTitle = `${title} ${allTutorialsPostsFilter} ${subtitle}`;
  const url = `${cta?.url}`;
    const toggleFilter = () => {
        setAllTutorialsPostsFilter(allTutorialsPostsFilter === 'recent' ? 'popular' : 'recent');
      };

  return (
    // <button onClick={toggleFilter}>Toggle Filter</button>
    <Posts
      title={sectionTitle}
      posts={posts}
      action={<Link to={url}>{cta?.label}</Link>}
    />
  );
};
export default  FilteredPosts
